<ng-container *mobxAutorun>
  <div
    #modal
    class="modal"
    [class.fade]="animate"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="modal-dialog {{ size ? 'modal-' + size : '' }}"
      [class.modal-dialog-centered]="isCentered"
    >
      <div class="modal-content" role="document"><ng-content></ng-content></div>
    </div>
  </div>
</ng-container>
